import { createAction, props } from '@ngrx/store';
import { ContactFormItem } from './contact-form.models';

export const sendContactFormAction = createAction('[ContactForm] send contact', props<{ data: FormData }>());
export const sendContactFormSuccessAction = createAction('[ContactForm] send contact success');
export const sendContactFormFailureAction = createAction('[ContactForm] send contact failure', props<{ error: any }>());
